Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-inline-widget');
    if ($wrapper.length < 1)
        return;

    var wrapper = $wrapper.get(0);
    var model = null;
    var hasCookie = Cookies.get('InlineAdmin');

    wrapper.loading = function loading(loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        };
    };

    wrapper.update = function update() {

        wrapper.loading(true);

        var html = Vendd.Handlebars.parse("inlineAdmin", model);
        wrapper.bind(html);

        wrapper.loading(false);
    };

    wrapper.bind = function bind(html) {

        $wrapper.html(html);

        var loadJS = function (url, location, callback) {

            var scriptTag = document.createElement('script');

            scriptTag.src = url;

            if (!!callback && typeof callback === 'function') {

                scriptTag.onload = callback;
                scriptTag.onreadystatechange = callback;

            }

            location.appendChild(scriptTag);
        };

        loadJS('/system/js/plugins/q.js', document.body, function () {

            loadJS('https://cdn.ckeditor.com/ckeditor5/29.1.0/inline/ckeditor.js', document.body, function () {

                //var wrapper = $('.header-region .region-area-two');

                //wrapper.css("position", "relative"); 

                //var html = '<div class="js-inline-admin-edit-page-toolbar"> <a href = "javascript:void(0)" class="js-inline-admin-edit-page button fourth"> Edit</a><a href="javascript:void(0)" class="js-inline-admin-edit-page-undo button fourth hidden disabled">Discard</a><a href="javascript:void(0)" class="js-inline-admin-edit-page-save button fourth hidden disabled">Save</a></div >';

                //wrapper.append(html);

                $('.js-inline-admin-edit-page').on('click', function (e) {

                    applyEditMode();

                    e.preventDefault();
                    e.stopPropagation();

                });

            });

        });

        $('.js-inline-admin-trigger').on('click', function () {

            this.href += '#' + encodeURIComponent(document.location.href);
        });

        var fancyOpts = {
            type: 'iframe',
            baseClass: "inline-admin-popup",
            toolbar: false,
            smallBtn: true
        };

        $("section.admin .iframe").fancybox(fancyOpts);

        $('.inline-admin-logout').on('click', '.js-logout', function (e) {
            e.preventDefault();

            Vendd.MessageBus.publishAsync($wrapper, new Vendd.User.Messages.Logout());
        });

        $('.inline-clear-cache').on('click', '.js-clear-cache', function (e) {
            e.preventDefault();

            var domain = document.location.hostname;
            var url = location.protocol + '//' + domain + '/engine/clearcache?cloudflare=true';
            $.post(url, function (data) {
                alert(data);
                location.reload();
            });
        });

        $('.inline-admin-newguest').on('click', function (e) {
            e.preventDefault();

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.InlineAdmin.Messages.CheckForInlineAdmin(true));

        });
        $('.inline-admin-clearinterfaceuser').on('click', function (e) {
            e.preventDefault();

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.UserSelect.Messages.ClearInterfaceUser());

        });

        $('section.admin .shippingCountry').on('click', function (e) {
            e.preventDefault();
            window.location.href = LhApp.Function.Url.setParameterValue("country", $(this).data("country"));
        });

        $('.header-spacer').addClass('has-inline-admin');
        $('.header-region').addClass('has-inline-admin');

    };

    wrapper.newGuid = function newGuid() {
        return ([1e7] + [-1e3] + [-4e3] + [-8e3] + [-1e11]).replace(/[018]/g, (parseInt('$2') ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> parseInt('$2') / 4).toString(16));
    };

    Vendd.MessageBus.subscribe(Vendd.UserSelect.Messages.ClearInterfaceUserSuccess, wrapper, function (envelope) {
        location.reload();
    });

    if (hasCookie) {
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.InlineAdmin.Messages.CheckForInlineAdmin());

        Vendd.MessageBus.subscribe(Vendd.InlineAdmin.Messages.CheckForInlineAdminSuccess, wrapper, function (envelope) {

            model = envelope.message.data.model.data;
            if (model.CallCenter.InterfaceUserIsNewGuest)
                location.reload();

            wrapper.update();
        });

        Vendd.MessageBus.subscribe(Vendd.InlineAdmin.Messages.CheckForInlineAdminFailure, wrapper, function (envelope) {
            Cookies.set('InlineAdmin', '', { expires: 0, samesite: 'Lax' });
        });

        Vendd.MessageBus.subscribe(Vendd.InlineAdmin.Messages.CreateCookieForInlineAdminSuccess, wrapper, function (envelope) {
            model = envelope.message.data.model;
            var redirectUrl = envelope.message.data.redirectUrl;

            hasCookie = Cookies.get('InlineAdmin');

            if (!hasCookie) {
                Cookies.set('InlineAdmin', wrapper.newGuid(), { expires: 1, samesite: 'Lax' });
            }

        });
    }

    var applyEditMode = function () {

        Q($.ajax({
            type: "POST",
            url: 'https://venddeshop.test.devlh.com/vendd/api/security/authenticate',
            data: JSON.stringify({
                Username: 'lh3admin@lighthouse.gr',
                Password: 'GEcp=9(U{{vS1y]s'
            }),
            dataType: 'json',
            contentType: 'application/json; charset=UTF-8',
            ContentType: 'application/json; charset=UTF-8',
            xhrFields: { withCredentials: true }
        }))
            .then(function (response) {

                var controls = controlFactory.Resolve($('body'));

                Q.all(controls
                    .map(function (x) {

                        var result = x.init();  // promisify this

                        if (!Q.isPromise(result)) {

                            result = Q.Promise(function (resolve, reject) {

                                resolve();

                            });

                        }

                        return result.then(function () {
                            return x;
                        });

                    }))
                    .then(function () {

                        controls.forEach(function (x) {

                            x.build();
                            x.render();
                            x.bind();

                        });

                    });

                $('.js-inline-admin-edit-page').addClass('hidden');
                $('.js-inline-admin-edit-page-undo').removeClass('hidden');
                $('.js-inline-admin-edit-page-save').removeClass('hidden');

            });

    };

    var controlFactory = (function () {

        var factoriesDictionary = {};

        var controlFactory = function () {

        };

        controlFactory.prototype.register = function (name, factory) {

            factoriesDictionary[name] = factory;

        };

        controlFactory.prototype.Resolve = function (wrapper) {

            var results = [];

            Object.keys(factoriesDictionary).forEach(function (x) {

                results = results.concat(factoriesDictionary[x]());

            });

            return results;

        };

        controlFactory.prototype.destroy = function () {

            factoriesDictionary = undefined;

        };

        return new controlFactory();

    })();

    var controlBase = (function () {

        var controlBase = function (element, definition) {

            this.element = element;
            this.definition = definition;

        };

        controlBase.prototype.init = function () {

        };

        controlBase.prototype.build = function () {

        };

        controlBase.prototype.render = function () {

        };

        controlBase.prototype.bind = function () {

        };

        return controlBase;

    })();

    (function () {

        var languageMappings = [
            { Id: 10, Code: 'bg' },
            { Id: 3, Code: 'de' },
            { Id: 1, Code: 'el' },
            { Id: 2, Code: 'en' },
            { Id: 4, Code: 'es' },
            { Id: 5, Code: 'fr' },
            { Id: 6, Code: 'it' },
            { Id: 9, Code: 'ro' },
            { Id: 7, Code: 'ru' },
            { Id: 8, Code: 'zh' }
        ];

        var control = function (element, definition) {

            var self = this;

            controlBase.apply(self, [element, definition]);

            self.productId = element.data('parent-id');
            self.skuId = element.data('selected-id');
            self.path = element.data('path');

        };

        control.prototype = Object.create(controlBase.prototype);

        control.prototype.init = function () {

            var self = this;

            controlBase.prototype.init.apply(self);

            var url = 'https://venddeshop.test.devlh.com/vendd/api/InlineAdmin/GetFullItemAsync';
            var data = {
                SiteId: self.definition.siteId,
                ItemId: self.productId,
                EntityCode: "product",
                ItemPathChecksum: self.path
            };

            return Q($.ajax({
                type: "POST",
                url: url,
                data: JSON.stringify(data),
                dataType: 'json',
                contentType: 'application/json; charset=UTF-8',
                ContentType: 'application/json; charset=UTF-8',
                xhrFields: { withCredentials: true }
            }))
                .then(function (response) {

                    self.row = response.data;

                    return data;

                });

        };

        control.prototype.render = function () {

            controlBase.prototype.render.apply(self);

            var self = this;

            self.titleContainer = $('.title-container h1.title', self.element);
            self.descriptionContainer = $('.tabs-content .tab-content.dynamic-content.extended-descritpion').eq(0); // TODO: change this

            var localization = self.row.ItemsLocalized.find(function (x) {
                return x.LanguageId === self.definition.languageId;
            });

            InlineEditor
                .create(self.titleContainer[0], {
                    toolbar: ["undo", "redo"]
                })
                .then(function (editor) {

                    self.titleEditor = editor;

                    editor.setData(localization.Name);

                    editor.model.document.on('change:data', function() {

                        $('.js-inline-admin-edit-page-undo').addClass('disabled')
                        $('.js-inline-admin-edit-page-save').addClass('disabled')

                        if (self.hasChanges()) {

                            $('.js-inline-admin-edit-page-undo').removeClass('disabled')
                            $('.js-inline-admin-edit-page-save').removeClass('disabled')

                        }

                    });

                })
                .catch(function (error) { console.error(error); });

            InlineEditor
                .create(self.descriptionContainer[0], {
                    toolbar: ["heading", "|", "bold", "italic", "link", "bulletedList", "numberedList", "|", "outdent", "indent", "|", "insertTable", "|", "undo", "redo"]
                })
                .then(function (editor) {

                    self.descriptionEditor = editor;

                    self.description = editor.getData();

                    editor.model.document.on('change:data', function() {

                        $('.js-inline-admin-edit-page-undo').addClass('disabled')
                        $('.js-inline-admin-edit-page-save').addClass('disabled')

                        if (self.hasChanges()) {

                            $('.js-inline-admin-edit-page-undo').removeClass('disabled')
                            $('.js-inline-admin-edit-page-save').removeClass('disabled')

                        }

                    });

                })
                .catch(function (error) { console.error(error); });

        };

        control.prototype.hasChanges = function () {

            var self = this;

            var localization = self.row.ItemsLocalized.find(function (x) {
                return x.LanguageId === self.definition.languageId;
            });

            return localization.Name !== $(self.titleEditor.getData()).text()
                || self.description !== self.descriptionEditor.getData();

        };

        controlFactory.register('products', function () {

            var results = [];

            $('.x-product-details').each(function () {

                var ctl = new control($(this), {
                    siteId: LhApp.Context.Site.Id,
                    languageId: languageMappings.find(function (x) { return x.Code === LhApp.Context.Language }).Id
                });

                results.push(ctl);

                $(this).data('vendd-control', ctl);

            });

            return results;

        });

    })();

});
